import { render, staticRenderFns } from "./MobileApp.vue?vue&type=template&id=fd7ba6d6&scoped=true&"
import script from "./MobileApp.vue?vue&type=script&lang=js&"
export * from "./MobileApp.vue?vue&type=script&lang=js&"
import style0 from "./MobileApp.vue?vue&type=style&index=0&id=fd7ba6d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7ba6d6",
  null
  
)

export default component.exports